import { CustomControlCode } from '@common/enums';
import { ServiceActivityRegistry } from '@common/workflow/serviceActivityRegistry';
import { bariPostEnrollmentReadSectionsV1 } from './v1/bariPostEnrollmentReadSectionsV1';
import { bariPostEnrollmentDraftSchemaV1, bariPostEnrollmentFinalSchemaV1 } from './v1/bariPostEnrollmentSchemaV1';
import { bariPostEnrollmentReadSectionsV2 } from './v2/bariPostEnrollmentReadSectionsV2';
import { bariPostEnrollmentDraftSchemaV2, bariPostEnrollmentFinalSchemaV2 } from './v2/bariPostEnrollmentSchemaV2';

const customControlCode = CustomControlCode.BariPostEnrollment;

ServiceActivityRegistry.instance.registerAll([
    {
        customControlCode,
        draft: bariPostEnrollmentDraftSchemaV1,
        final: bariPostEnrollmentFinalSchemaV1,
        readSections: bariPostEnrollmentReadSectionsV1,
        version: 1,
    },
    {
        customControlCode,
        draft: bariPostEnrollmentDraftSchemaV2,
        final: bariPostEnrollmentFinalSchemaV2,
        readSections: bariPostEnrollmentReadSectionsV2,
        version: 2,
    },
]);
